import {
  correspondenceListCorrespondenceDraftsOptions,
  useHeyApi,
} from "@platform/api";
import { useQuery } from "@tanstack/react-query";

import type { CorrespondenceDraft } from "@platform/api";

export interface CorrespondenceDrafts {
  drafts: CorrespondenceDraft[];
  isLoading: boolean;
  isError: boolean;
}

/**
 * The unsent replies on one RFP.
 *
 * Fetched only once the drawer is open: a drafts listing is a second read,
 * and nothing on the RFP page asks the question until the drawer does.
 *
 * `rfpId` is the RFP's canonical identifier. The BFF resolves an ecosystem id
 * to the uuid before reading, so either form works.
 */
export const useCorrespondenceDrafts = (
  rfpId: string | undefined,
): CorrespondenceDrafts => {
  const { centroPortalClient } = useHeyApi();

  const { data, isLoading, isError } = useQuery({
    ...correspondenceListCorrespondenceDraftsOptions({
      query: { rfpId: rfpId ?? "" },
      client: centroPortalClient,
    }),
    enabled: !!rfpId,
  });

  return {
    drafts: data?.drafts ?? [],
    // A drawer opened before its RFP identifier resolved is waiting, not
    // idle: the query is disabled, so react-query reports neither state.
    isLoading: isLoading || !rfpId,
    isError,
  };
};
